<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/dsales/index">Manage Sales</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        {{ quatations.so_num || 'View Sales' }}
      </h6>

      <div class="container-fluid">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <button v-if="quatations.status_value == 1" @click="confirmSale" class="btn btn-sm btn-outline-primary mb-1 bdr-rad">Confirm</button>
          <button @click="goBack" class="btn btn-sm btn-outline-primary mb-1 bdr-rad">Back</button>
        </div>

        <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
          <div class="card-body custom_bdr_rds">
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="mt-1">
          <div class="card custom_bdr_rds shadow p-2">
            <div class="card-body custom_bdr_rds">
              <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                <tbody>
                  <tr><td class="width-custom2"><b>Customer</b></td><td>{{ quatations.C_name }}</td></tr>
                  <tr><td><b>Customer Contact</b></td><td>{{ quatations.customer_contact }}</td></tr>
                  <tr><td><b>Payment Method</b></td><td>{{ quatations.payment_method }}</td></tr>
                  <tr><td><b>Status</b></td><td>{{ quatations.status }}</td></tr>
                  <tr><td><b>Created Date</b></td><td>{{ quatations.created_date }}</td></tr>
                  <tr><td><b>Created By</b></td><td>{{ quatations.username }}</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card custom_bdr_rds shadow p-2">
            <div class="card-body custom_bdr_rds">
              <h6 class="purchitem mb-2"><b>Added Products</b></h6>
              <div class="table-responsive">
                <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                  <thead class="background_color2">
                    <tr class="custom-label2">
                      <th>#</th>
                      <th>Product</th>
                      <th class="text_right">Price</th>
                      <th class="text_right">Qty</th>
                      <th class="text_right">Discount</th>
                      <th class="text_right">Line Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(detail, index) in details" :key="detail.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ detail.P_description }} ({{ detail.P_code }})</td>
                      <td class="text_right">{{ detail.price }}</td>
                      <td class="text_right">{{ detail.qty }}</td>
                      <td class="text_right">{{ detail.line_discount }}</td>
                      <td class="text_right">{{ detail.line_amount }}</td>
                    </tr>
                    <tr style="border-top: 2px solid black;">
                      <td></td>
                      <th>Total :</th>
                      <td></td>
                      <td class="text_right">{{ total.total_qty }}</td>
                      <td></td>
                      <th class="text_right">{{ total.total_line_amount }}</th>
                    </tr>
                    <tr>
                      <td></td>
                      <th>Special Discount :</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <th class="text_right">{{ total.special_discount }}</th>
                    </tr>
                    <tr>
                      <td></td>
                      <th>Total :</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <th class="text_right">{{ total.sub_total }}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3 mb-2">
            <button
              v-if="quatations.status_value == 3"
              type="button"
              class="btn btn-outline-primary bdr-rad"
              @click="createGin"
            >
              Create GIN
            </button>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: {
    TopNavbar,
    ContentFooter,
  },
  mounted() {
    this.loadSales();
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      id: this.$route.query.id,
      quatations: {},
      total: {},
      details: [],
      isLoading: true,
    };
  },
  methods: {
    goBack() {
      this.$router.push('/dsales/index');
    },
    createGin() {
      this.$router.push('/dgin/create?id=' + this.id);
    },
    async confirmSale() {
      try {
        const { data } = await axios.get('/dsales/confirm?id=' + this.id, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });
        if (data && data.status === 200) {
          await this.loadSales();
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
    async loadSales() {
      try {
        const { data } = await axios.get('/dsales/view?id=' + this.id, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });
        this.quatations = data.quatations || {};
        this.total = data.total || {};
        this.details = data.details || [];
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.bdr-rad {
  border-radius: 12px;
}

.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}
</style>
